export default __webpack_public_path__ + "static/avatarGirl2-821790b262acf054a229625d70edebe8.jpeg";